const timeToWaitInSeconds = 3;
const secondsToMilliseconds = 1000;
const NOTHING_TO_SEND = 'NOTHING_TO_SEND';
const WAITING_TO_SEND = 'WAITING_TO_SEND';
const states = [NOTHING_TO_SEND, WAITING_TO_SEND];
export const createContentViewedEventInitialState = function () {
  let {
    inFlight = [],
    state = NOTHING_TO_SEND
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    inFlight,
    state
  };
};
export const createProductListViewedEventInitialState = function () {
  let {
    inFlight = [],
    state = NOTHING_TO_SEND
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    inFlight,
    state
  };
};
const createTrackProductListViewedEvent = function (prepareProductListViewedEventData, trackEvent) {
  let initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createProductListViewedEventInitialState({});
  let {
    inFlight,
    state
  } = initialState;
  const finalize = () => {
    const items = inFlight;
    inFlight = [];
    state = NOTHING_TO_SEND;
    Object.values(items.reduce((acc, _ref) => {
      let {
        product,
        options: {
          listId,
          sortMethod
        }
      } = _ref;
      const key = "listId:".concat(listId, ";sortMethod:").concat(sortMethod);
      const batch = acc[key] || {
        products: [],
        listId,
        sortMethod
      };
      batch.products.push(product);
      acc[key] = batch;
      return acc;
    }, {})).forEach(_ref2 => {
      let {
        products,
        listId,
        sortMethod
      } = _ref2;
      const deduppedProducts = [...new Set(products)];
      trackEvent({
        type: 'legacy',
        data: prepareProductListViewedEventData(deduppedProducts, listId, sortMethod)
      });
    });
  };
  return {
    context: (product, _ref3) => {
      let {
        listId,
        sortMethod = ''
      } = _ref3;
      inFlight = [...inFlight, {
        product,
        options: {
          listId,
          sortMethod
        }
      }];
      if (state === NOTHING_TO_SEND) {
        state = WAITING_TO_SEND;
        setTimeout(finalize, timeToWaitInSeconds * secondsToMilliseconds);
      }
    },
    finalize
  };
};
export const createAnalyticsImpressionTrackerState = _ref4 => {
  let {
    productListViewed,
    trackEvent
  } = _ref4;
  const trackProductListViewedEvent = createTrackProductListViewedEvent(productListViewed.transform, trackEvent, productListViewed.state);
  return {
    context: {
      trackProductListViewedEvent: trackProductListViewedEvent.context
    },
    finalize: () => {
      trackProductListViewedEvent.finalize();
    }
  };
};